/*
 * tab-lazy-load.js
 * Fills inactive product-tabs panels on demand instead of server-rendering every
 * tab inline. The active (first) tab is rendered by the section; other panels carry
 * data-lazy-tab="true" + data-collection-url and are populated by:
 *   - Trigger A: clicking the tab header (fast path), and
 *   - Trigger B: an idle prefetch after window load.
 * Fetches /collections/<handle>?view=tab-ajax (templates/collection.tab-ajax.liquid,
 * {% layout none %}) which returns only the product cards, reusing the same snippet
 * as the inline tab so markup matches.
 */
(function () {
  if (window.__tabLazyLoadInit) return;
  window.__tabLazyLoadInit = true;

  var filled = new WeakSet();

  function schedule(fn) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fn, { timeout: 2000 });
    } else {
      setTimeout(fn, 200);
    }
  }

  // Slider re-init for tab pages that enable the carousel (road-bike-tabs is grid,
  // so this is a no-op there). Custom elements in the cards self-upgrade on inject;
  // only the controller-based Swiper needs a nudge.
  function reinitSlider(panel) {
    if (panel.getAttribute('data-enable-slide') !== 'true') return;
    try {
      var list = panel.querySelector('.m-product-list');
      if (list && window.MinimogTheme && typeof window.MinimogTheme.ProductList === 'function') {
        new window.MinimogTheme.ProductList(list);
      }
    } catch (e) {
      /* slider is optional; never block the grid render */
    }
  }

  function fill(panel) {
    if (!panel || filled.has(panel) || panel.dataset.lazyLoading === 'true') return;
    var url = panel.dataset.collectionUrl;
    var container = panel.querySelector('[data-products-container]');
    if (!url || !container) return;

    panel.dataset.lazyLoading = 'true';
    var sep = url.indexOf('?') === -1 ? '?' : '&';

    fetch(url + sep + 'view=tab-ajax', { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // The {% layout none %} view returns just the cards as <body> children.
        container.innerHTML = doc.body.innerHTML;
        filled.add(panel);
        panel.removeAttribute('data-lazy-tab');
        reinitSlider(panel);
      })
      .catch(function () {
        // Leave the panel empty on failure; the "View all" link still works.
      })
      .finally(function () {
        panel.dataset.lazyLoading = 'false';
      });
  }

  function lazyPanels() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.m-tab-content[data-lazy-tab="true"]')
    );
  }

  // Trigger A: fill the matching panel as soon as its tab header is clicked.
  document.addEventListener(
    'click',
    function (e) {
      var header = e.target.closest && e.target.closest('.m-tab-header');
      if (!header) return;
      var idx = header.getAttribute('data-index');
      if (idx == null) return;
      var scope = header.closest('.m-section') || document;
      var panel = scope.querySelector(
        '.m-tab-content[data-index="' + idx + '"][data-lazy-tab="true"]'
      );
      if (panel) fill(panel);
    },
    true
  );

  // Trigger B: prefetch the rest during idle, one at a time, after load.
  function prefetchAll() {
    var panels = lazyPanels();
    var i = 0;
    (function next() {
      if (i >= panels.length) return;
      fill(panels[i++]);
      schedule(next);
    })();
  }

  if (document.readyState === 'complete') {
    schedule(prefetchAll);
  } else {
    window.addEventListener('load', function () { schedule(prefetchAll); });
  }
})();
